<template>
  <fragment>
    <c-technologies-split invert-mobile top-divider image-fill />

    <c-cta split />
  </fragment>
</template>

<script>
// import layout
import CLayout from "@/layouts/LayoutAlternative.vue";
// import section header
// import sections
import CTechnologiesSplit from "@/components/sections/TechnologiesSplit.vue";
import CCta from "@/components/sections/Cta.vue";

export default {
  name: "Secondary",
  components: {
    CTechnologiesSplit,
    CCta
  },
  data() {
    return {};
  },
  created() {
    this.$emit("update:layout", CLayout);
  }
};
</script>
